// extracted by mini-css-extract-plugin
export default {"page":"video-preview_page__RHWll","pageContent":"video-preview_pageContent__BBdyw","main":"video-preview_main__SypBw","mainContent":"video-preview_mainContent__vwcee"};